--------README --------------------------------------------------------------------------------
ici des commentaires liées au composant
------------------------------------------------------------------------------------------------

<template>

    <div class="menu" :class="{'menu-isOpen' : isOpen}">
        <div class="menu_btn">
            <ButtonBurger @click.native="toggleClick" :isOpen="isOpen"></ButtonBurger>
        </div>

        <div class="menu_nav menu_nav-left" @click="prev()" :class="{'menu_nav-disabled' : isFirstPage}">
            <FaIcon name="chevron-left" />
        </div>
        <div class="menu_nav menu_nav-right" @click="next()" :class="{'menu_nav-disabled' : isLastPage}">
            <FaIcon name="chevron-right" />
        </div>

        <div class="menu_panel" ref="menu_panel">
            <a class="menu_item"
                 :class="{'menu_item-dark': item.theme}"
                 v-for="(item, index) in menuItems"
                 @click.prevent="clickOnMenuItem"
                 :data-segment="$t(`menu.${item.pageComponent}.segment`)"
                 :href="$t(`menu.${item.pageComponent}.segment`)+'/index.html'"
                 :data-intro="item.intro"
                 :data-index="index">
                <div class="menu_item_content" :style="{'background-image': 'url(' + imgPath(item.image) + ')', 'background-position': item.imageOffset}">
                    <div class="menu_item_label" v-html="$t(`menu.${item.pageComponent}.title`)"></div>
                    <ButtonMagnetic :color="getBtnColor(item.theme)"></ButtonMagnetic>
                    <div class="menu_item_shutter"></div>
                </div>
            </a>
        </div>

        <div class="menu_intro" ref="menu_intro">
            <div class="menu_intro_item"
                 v-for="(item, index) in menuItems"
                 :data-index="index"
                 :style="{'background-image': 'url(' + imgPath(item.image) + ')', 'background-position': item.imageOffset}">
            </div>
        </div>


    </div>

</template>

<script>
    import $ from 'jquery';
    import {EMenuIntro} from '@/constants/conf';
    import {TimelineMax, TweenMax} from 'gsap';
    import ButtonMagnetic from './ButtonMagnetic.vue';
    import {Locales} from '../plugin/Locales';
    import ButtonBurger from "./ButtonBurger";
    import Verge from 'verge';
    import FaIcon from "./FaIcon.vue";
    import {Device, EBreakPoint} from '../utils/Device';
    import { debounce } from "debounce";
    import {i18n} from "../plugin/i18n";


    export default {
        name: 'Menu',
        components: {FaIcon, ButtonBurger, ButtonMagnetic},
        data() {
            return {
                isOpen: false,
                TL_menu: false,
                menuItems: [],
                isFirstPage: true,
                isLastPage: false,
                currentPage: 1,
                itemsPerPage: 0,
            };
        },
        watch: {
            $route: function() {
                this.close();
            },
            currentPage: function(){
                this.isFirstPage = (this.currentPage === 1);
                this.isLastPage = (this.currentPage === this._totalPage);
            }
        },
        mounted() {
            // on recupere les entrées du menu via notre objet de trad
            this.menuItems = Locales.mainMenu;
            // on ecoute un evenement (possibilité d'ouvrir le menu depuis d'autre composants)
            this.$events.on('menu-openSummary', () => {this.open()});
            this.$events.on('pageTransitionEnterDone', () => {this.closeIntro();});

            window.onresize = debounce( () => {this.init();}, 200);
            // on configure les propriete pour notre menu (pour la navigation)
            //this.init();
        },
        updated() {
            this.init();
        },
        methods: {
            getBtnColor(theme){
              if(theme){
                  return '#000';
              }   else {
                  return '#fff';
              }
            },
            init(){
                // on change le nombre d'item en fonction de la taille du viewport
                let offset = 16; // - 4px dans le calcue de la taille de l'item
                Device.refresh();
                if(Device.isUpTo(EBreakPoint.SM)){
                    this.itemsPerPage = 5;
                } else {
                    this.itemsPerPage = 2;
                    offset = 10;
                }
                this._totalPage = Math.ceil(this.menuItems.length / this.itemsPerPage);
                this._remainingItems = this.menuItems.length % this.itemsPerPage;
                this._itemWidth = (Device.vp.w / this.itemsPerPage) - offset;

                let itemWidth = this._itemWidth;
                $('.menu_item').each(function(index){
                    $(this).css({
                        'width' : itemWidth,
                        'left' : (index * itemWidth) + 20*index,
                    });
                });
            },
            clickOnMenuItem(event){
                let $item = $(event.target).parents('.menu_item');

                // pas de clic si on est sur la page courante
                if('page' in this.$route.params){
                    if(this.$route.params.page === $item.data('segment')){
                        // on remet le scroll de la page en haut
                        $('.pageSelector .page').scrollTop(0);
                        // on ferme le menu
                        this.close();
                        return;
                    }
                }

                // en fonction du menu on va switcher les intro possible
                switch ($item.data('intro')) {
                    // par defaut, on fait la transition quir arrive par le base
                    case EMenuIntro.DEFAULT :
                        this.$router.push({ name: 'page', params: { page: $item.data('segment') } });
                        break;
                    // la transition ARTICLE correspond au grossisement de l'item (kumano like)
                    case EMenuIntro.ARTICLE :
                        this.launchIntroArticle($item);
                        break;
                    // la transition ARTICLESIMPLE correspond au grossisement de l'item (kumano like)
                    case EMenuIntro.ARTICLESIMPLE :
                        this.launchIntroSimpleArticle($item);
                        break;
                    // la transition POINTOFVIEW correspond au déplacement de l'item sur la guahce (comme pour l'edito)
                    case EMenuIntro.POINTOFVIEW :
                        // on lance une intro sauf sur mobile,
                        // pas top, mais je vois pas trop comment faire la tranistion entre les deux état sans passer bcp de temps
                        if(Device.isUpTo(EBreakPoint.SM)){
                            this.launchIntroPointOfView($item);
                        } else {
                            this.$router.push({ name: 'page', params: { page: $item.data('segment') } });
                        }
                        break;
                    default :
                        this.$router.push({ name: 'page', params: { page: $item.data('segment') } });
                        break;
                }
            },
            closeIntro(){
                let t = new TimelineMax();
                t.to(this.$refs.menu_intro, 0.5, {alpha:0, ease: Expo.easeInOut});
                t.set(this.$refs.menu_intro, {display: 'none'});
            },
            setIntro($el){
                let index = $el.data('index');
                let $intro = $('.menu_intro_item[data-index='+index+']');
                $intro.css('display', 'block');
                $intro.siblings().css('display', 'none');
            },
            launchIntroPointOfView($el){

                //console.debug($el);
                this.setIntro($el);
                let elInfos = Verge.rectangle($el);
                let t = new TimelineMax();
                t.fromTo(this.$refs.menu_intro, 0.5, {width: this._itemWidth,  display:'block', alpha:0, x: elInfos.left}, {alpha:1});
                t.to($('.menu_item_shutter'), 1, {scaleX: 1, ease: Expo.easeIn});
                t.add([
                    TweenMax.to(this.$refs.menu_intro, 2, {x: 0, ease: Expo.easeOut}),
                ]);
                t.add(() => {
                    this.$router.push({ name: 'page', params: { page: $el.data('segment') } })
                });
            },
            launchIntroSimpleArticle($el){
                //console.debug($el);
                this.setIntro($el);
                let elInfos = Verge.rectangle($el);
                let t = new TimelineMax();
                t.fromTo(this.$refs.menu_intro, 0.5, {width: this._itemWidth,  display:'block', alpha:0, x: elInfos.left}, {alpha:1});
                t.to($('.menu_item_shutter'), 1, {scaleX: 1, ease: Expo.easeIn});
                t.add([
                    TweenMax.to(this.$refs.menu_intro, 2, {x: 0, ease: Expo.easeOut}),
                ]);
                t.add(() => {
                    this.$router.push({ name: 'page', params: { page: $el.data('segment') } })
                });
            },
            launchIntroArticle($el){
                //console.debug($el);
                this.setIntro($el);
                let elInfos = Verge.rectangle($el);
                let t = new TimelineMax();
                t.fromTo(this.$refs.menu_intro, 0.5, {width: this._itemWidth,  display:'block', alpha:0, x: elInfos.left}, {alpha:1});
                t.to($('.menu_item_shutter'), 0.6, {scaleX: 1, ease: Expo.easeIn});
                t.add([
                    TweenMax.to(this.$refs.menu_intro, 2, {x: 0, width: '100%', ease: Expo.easeOut}),
                ]);
                t.add(() => {
                    this.$router.push({ name: 'page', params: { page: $el.data('segment') } })
                });
            },
            next() {
                if(this.currentPage < this._totalPage){
                    this.currentPage += 1;
                    this.move();
                }
            },
            prev() {
                if(this.currentPage > 1){
                    this.currentPage -= 1;
                    this.move();
                }
            },
            move() {
                let wpWidth = Device.vp.w + 20;
                let offset = (this.currentPage-1)*wpWidth;

                // si jamais nous essayons l'aller sur la dernier page du menu, nous verons un décalage moins important
                // en effet nous ne voulons slider la totalité de la page, mais juste les éléments restants
                if(this.currentPage === this._totalPage && this._remainingItems > 1){
                    offset = offset - ((this.itemsPerPage - this._remainingItems)*wpWidth/this.itemsPerPage);
                }

                TweenMax.to(this.$refs.menu_panel, 0.6, {
                    x: -offset,
                    ease: Expo.easeInOut,
                });
            },
            toggleClick() {
                if (this.isOpen) {
                    this.close();
                } else {
                    this.open();
                }
            },
            reset() {
                TweenMax.set($('.menu_item_shutter'), {scaleX: 0});
                TweenMax.set(this.$refs.menu_intro, {display: 'none', width: 0});
                // on repositionne le containter sur les premier éléménts
                //TweenMax.set(this.$refs.menu_panel, { x: 0 });
                //this.currentPage = 1;
                //$('.menu_intro_item').css('display', 'none');
            },
            open() {
                this.isOpen = true;
                this.$events.fire('menu-isOpening');
                this.reset();

                if (this.TL_menu) {
                    this.TL_menu.pause();
                }
                this.TL_menu = new TimelineMax({
                    onComplete: () => { this.$events.fire('ButtonMagneticUpdate'); },
                });
                this.TL_menu.set(this.$refs.menu_panel, {visibility: 'visible'});
                this.TL_menu.add([
                    TweenMax.staggerFromTo($('.menu_item'), 0.5,
                        {
                            yPercent: -100,
                        },
                        {
                            yPercent: 0,
                            ease: Expo.easeInOut,
                        },
                        0.1),
                ]);
                $('body').addClass('menu-open');

            },
            close() {
                this.isOpen = false;
                this.$events.fire('menu-isClosing');
                if (this.TL_menu) {
                    this.TL_menu.pause();
                }
                this.TL_menu = new TimelineMax();
                this.TL_menu.add([
                    TweenMax.staggerTo($('.menu_item'), 0.5, {
                        yPercent: -100,
                        ease: Expo.easeInOut,
                    },
                    0.1),
                ]);
                this.TL_menu.set(this.$refs.menu_panel, {visibility: 'hidden'});
                $('body').removeClass('menu-open');
            },
            imgPath(image) {
                return require('../assets/img/'+image);
            },
        },
    };
</script>

<style scoped lang="scss">

    .menu{

        width: 100%;
        height: 100vh;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;

        &_btn{
            position: fixed;
            right: $G-default;
            top: $G-default;
            z-index: $ZI-menuBtn;
            cursor: pointer;
            @include transition();
        }

        &_nav{
            position: fixed;
            top: 50vh;
            z-index: $ZI-menuBtn;
            width: 2rem;
            color: #fff;
            opacity: 1;
            cursor: pointer;
            padding: $G-default / 2 ;
            box-sizing: content-box;
            @include transition(all, 1s);

            &-disabled{
                opacity: 0;
            }

            svg{
                width: 100%;
                height: auto;
            }

            &-left{
                left: $G-default;
                transform: translateX(-250%);
            }
            &-right{
                right: $G-default;
                transform: translateX(250%);
            }
        }

        &_panel{
            position: absolute;
            left: 0;
            top: 0;
            min-width: 100%;
            height: 100vh;
            z-index: $ZI-menuPanel;
            //align-content: center;
            //display: flex;
            visibility: hidden;
        }

        &_item{
            display: block;
            position: absolute;
            top: 0;

            height: 100vh;
            color: #fff;
            background-color: #fff;
            padding: 0 20px 0 0;
            cursor: pointer;
            //width: calc(50vw + 10px);

            &-dark{
                color: #000;
            }

            @include breakpoint(md){
                flex: 0 1 20vw;
            }

            &_content{
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
                padding: $G-default*3.5 $G-default $G-default $G-default;
                height: 100%;
                position: relative;
            }

            &_shutter{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                transform: scaleX(0);
                transform-origin: left top;
                background: #fff;
            }

            &_label{
                font-family: $F-Montserrat;
                margin-bottom:  $G-default/2;
                color: currentColor;
                display: block;
                text-transform: uppercase;
                font-size: 2.5rem;
                font-weight: $FW-bold;
            }

        }

        &_intro{
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            z-index: $ZI-menuPanel + 1;
            display: none;

            &_item{
                background-position: center center;
                background-size: cover;
                height: 100%;
                width: 100%;
                position: absolute;
                left: 0;
                top: 0;
                display: none;
            }
        }


        &-isOpen{
            .menu_nav{
                transform: translateX(0);
            }
        }
    }

</style>